module.exports = __webpack_public_path__ + "img/CloseCombatMaster.9ecd04fc.png";